function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWithoutText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M32 1c2.2 0 4 1.7 4 3.8s-1.8 3.8-4 3.8-4-1.7-4-3.8S29.9 1 32 1M1.8 8.7h19.7c.4 0 .8-.3.8-.8V1.8c.1-.4-.3-.8-.7-.8H1.8c-.4 0-.8.3-.8.8v6.1c0 .4.4.8.8.8m7.1 26.7v-20c0-.4-.3-.6-.7-.6H1.7c-.4-.1-.7.2-.7.5v20c0 .4.3.7.7.7h6.6c.3 0 .6-.3.6-.6m6.3.6h19.9c.4 0 .7-.3.7-.7V29c0-.4-.3-.7-.7-.7H15.2c-.4 0-.7.3-.7.7v6.3c0 .4.4.7.7.7m12.9-17.5c0 2.1 1.8 3.8 4 3.8s4-1.7 4-3.8-1.8-3.8-4-3.8-4 1.7-4 3.8m-13.6 0c0 2.1 1.8 3.8 4 3.8s4-1.7 4-3.8-1.8-3.8-4-3.8-4 1.7-4 3.8",
    style: {
      fill: "#00edb9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithoutText);
export default __webpack_public_path__ + "static/media/logo-without-text.c1f6f8d8e5110d97486e14f7b941683a.svg";
export { ForwardRef as ReactComponent };